import React from 'react';
import EditableTable from '../../components/EditableTable';
import MultiSelectField from '../../components/MultiSelectField';
import {Box, TextField} from '@mui/material';
import FileUpload from "../../components/FileUpload";
import FileDownload from "../../components/FileDownload";
import FileDelete from "../../components/FileDelete";

export default function ExamsTable({ exams, onExamsChange, visitID }) {
    const headers = ['Tipo', 'Notas', 'Resultados'];
    const EXAM_TYPES = [
        "Aislamiento",
        "Analisis de Heces",
        "Antibiograma",
        "Biopsia",
        "Bioquímica",
        "Citologia",
        "E.C.G.",
        "Ecografias",
        "Frotis vaginal",
        "Hemograma",
        "Hormonales",
        "Orina",
        "Radiografias",
        "Otro"
    ];

    const cellTemplates = {
        type: {
            read: (value) => value || '',
            edit: (value, onChange) => (
                <MultiSelectField
                    value={Array.isArray(value) ? value : value.split(', ')}
                    items={EXAM_TYPES}
                    onChange={v => onChange(v.filter(Boolean).join(', '))}
                />
            ),
        },
        notes: {
            read: (value) => value || '',
            edit: (value, onChange) => (
                <TextField
                    variant="standard"
                    value={value || ''}
                    onChange={(e) => onChange(e.target.value)}
                />
            ),
        },
        filesPackage: {
            read: (value) => (
                <Box sx={{display: 'flex', gap: 1}}>
                    {value?.files?.map((file, index) => (
                        <FileDownload key={index} fileName={file.name} fileId={file.id}/>
                    ))}
                </Box>
            ),
            edit: (value, onChange) => (
                <Box sx={{display: 'flex', gap: 1, alignItems: 'center'}}>
                    <FileUpload
                        onFileUpload={onChange}
                        parentType="Visit"
                        packageID={value?.id}
                        parentID={visitID}
                    />
                    {value?.files?.map((file, index) => (
                        <Box sx={{display: 'flex', alignItems:'center'}} key={index}>
                            <FileDownload key={index} fileName={file.name} fileId={file.id}/>
                            <FileDelete key={index} fileId={file.id}
                                        onDelete={(fileId) => onChange({
                                            ...value,
                                            files: value.files.filter(f => f.id !== fileId)
                                        })}/>
                        </Box>
                    ))}
                </Box>
            ),
        },
    };

    const getNewRow = () => ({
        id: null,
        type: '',
        notes: '',
        filesPackage: {files: []},
    });

    return (
        <EditableTable
            headers={headers}
            data={exams}
            onDataChange={onExamsChange}
            cellTemplates={cellTemplates}
            getNewRow={getNewRow}
            title="Exámenes Complementarios"
        />
    );
}

